import { loadDefaultJapaneseParser } from "budoux";

/**
 * 題名を、折り返してよい切れ目ごとの塊（文節）に分ける。
 * BudouX（Google の日本語の文節区切り）で分け、空白の所でも区切る（空白は前の塊に付ける）。
 * BudouX が1つの塊として返す長い語（「戦乙女ヴァルキリー整備マニュアル」など）は、
 * 語の境目（カタカナと漢字の切り替わり・中黒）でさらに分ける。分けないと、表紙に収まらないとき
 * 「ヴァルキリー取扱説明 ／ 書」のように語の途中で折るしかなくなるため。
 */
const parser = loadDefaultJapaneseParser();

/** これより長い塊だけ、語の境目でさらに分ける（短い塊はそのまま。折れる所を増やしすぎない） */
const LONG_CHUNK = 7;
const KATAKANA = /[\p{Script=Katakana}ー]/u;
const KANJI = /[\p{Script=Han}々]/u;
/** ひらがな・記号で始まる語は前の語にくっつける（「の」「に関する」が行頭に来ないように） */
const ATTACH = /^[\p{Script=Hiragana}ー・、。！？!?」』）)\s]/u;

function scriptOf(ch: string): "kata" | "kanji" | "other" {
  return KATAKANA.test(ch) ? "kata" : KANJI.test(ch) ? "kanji" : "other";
}

/**
 * 長い塊を、カタカナ⇔漢字の切り替わりと中黒の後ろで分ける。
 * 2文字未満の欠片は作らない（「アルカディア市」の「市」、「2891年版」の「版」のような1文字の続きは前に付けたまま）
 */
function splitLongChunk(chunk: string): string[] {
  if (chunk.length <= LONG_CHUNK) return [chunk];
  const chars = [...chunk];
  const runFrom = (i: number) => {
    let n = 0;
    while (i + n < chars.length && scriptOf(chars[i + n]) === scriptOf(chars[i])) n++;
    return n;
  };
  const pieces: string[] = [];
  let cur = "";
  for (let i = 0; i < chars.length; i++) {
    const ch = chars[i];
    const prev = cur.at(-1);
    const boundary =
      prev !== undefined &&
      cur.length >= 2 &&
      (prev === "・" ||
        (scriptOf(prev) !== scriptOf(ch) && scriptOf(prev) !== "other" && scriptOf(ch) !== "other" && runFrom(i) >= 2));
    if (boundary && !ATTACH.test(ch)) {
      pieces.push(cur);
      cur = "";
    }
    cur += ch;
  }
  if (cur) {
    // 最後が1文字だけなら前にくっつける
    if (cur.length < 2 && pieces.length > 0) pieces[pieces.length - 1] += cur;
    else pieces.push(cur);
  }
  return pieces;
}

export function splitPhrases(text: string): string[] {
  const phrases: string[] = [];
  for (const part of text.split(/(?<=\s)/)) {
    if (part.trim() === "") {
      if (phrases.length > 0) phrases[phrases.length - 1] += part;
      else phrases.push(part);
      continue;
    }
    for (const chunk of parser.parse(part)) phrases.push(...splitLongChunk(chunk));
  }
  return phrases;
}
